"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sidebar = exports.SidebarDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var sidebar_section_1 = require("./sidebar-section");
var app_logo_1 = require("./app-logo");
var sidebar_menu_button_1 = require("./sidebar-menu-button");
var use_app_sections_1 = require("../../hooks/use-app-sections");
var router_1 = require("@reach/router");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var use_modal_1 = require("../../hooks/use-modal");
var use_sidebar_1 = require("../../hooks/use-sidebar");
var use_active_app_sections_1 = require("../../hooks/use-active-app-sections");
var use_active_app_sub_sections_1 = require("../../hooks/use-active-app-sub-sections");
var use_app_screen_1 = require("../../hooks/use-app-screen");
var use_entities_1 = require("../../hooks/use-entities");
var use_followable_entities_1 = require("../../hooks/use-followable-entities");
var use_active_person_1 = require("../../hooks/use-active-person");
var current_user_can_1 = require("../../utils/current-user-can");
var dialog_1 = require("../elements/dialog");
var terms_content_scroll_view_1 = require("../entities/terms-content-scroll-view");
var icon_label_1 = require("../elements/icon-label");
var sprintf_js_1 = require("sprintf-js");
var entity_sidebar_list_link_1 = require("../entities/entity-sidebar-list-link");
var entity_sidebar_group_1 = require("../entities/entity-sidebar-group");
var lodash_1 = require("lodash");
var entity_sidebar_list_group_1 = require("../entities/entity-sidebar-list-group");
var shapeable_logo_1 = require("./shapeable-logo");
var use_sidebar_pages_1 = require("../../hooks/use-sidebar-pages");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var current_path_name_1 = require("../../utils/current-path-name");
var entity_value_conversation_link_1 = require("../entities/entity-value-conversation-link");
var use_conversation_channels_1 = require("../../hooks/use-conversation-channels");
var env_1 = require("../../env");
exports.SidebarDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    -webkit-user-select: none;  /* Chrome all / Safari all */\n    -moz-user-select: none;     /* Firefox all */\n    -ms-user-select: none;      /* IE 10+ */\n    user-select: none;          /* Likely future */     \n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    background: ", ";\n  "], ["\n    -webkit-user-select: none;  /* Chrome all / Safari all */\n    -moz-user-select: none;     /* Firefox all */\n    -ms-user-select: none;      /* IE 10+ */\n    user-select: none;          /* Likely future */     \n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    background: ", ";\n  "])), theme_1.theme.COLOR('app-chrome'))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-shrink: 0;\n    display: flex;\n    justify-content: space-between;\n    padding: ", ";\n    -webkit-user-select: none;\n    -webkit-app-region: drag;\n  "], ["\n    flex-shrink: 0;\n    display: flex;\n    justify-content: space-between;\n    padding: ", ";\n    -webkit-user-select: none;\n    -webkit-app-region: drag;\n  "])), theme_1.theme.UNIT(5))
});
var MenuButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: ", ";\n    cursor: pointer;\n    -webkit-app-region: no-drag;\n  "], ["\n    margin-top: ", ";\n    cursor: pointer;\n    -webkit-app-region: no-drag;\n  "])), theme_1.theme.UNIT(1))
});
var LogoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 220px;\n    text-decoration: none;\n    * {\n      text-decoration: none;\n    }\n  "], ["\n    width: 220px;\n    text-decoration: none;\n    * {\n      text-decoration: none;\n    }\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 190px;\n  "], ["\n    width: 190px;\n  "])))
});
var FooterStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n    padding: ", " ", ";\n  "], ["\n    ", ";\n    padding: ", " ", ";\n  "])), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(4), theme_1.theme.UNIT(5))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    flex-grow: 1;\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  "], ["\n    flex-grow: 1;\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  "])))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TermsDialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    text-align: left;\n    height: 100vh;\n    max-width: 900px;\n  "], ["\n    text-align: left;\n    height: 100vh;\n    max-width: 900px;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    height: 80vh;\n  "], ["\n    height: 80vh;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    max-width: 900px;\n  "], ["\n    max-width: 900px;\n  "])))
});
var CopyrightStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    text-decoration: none;\n    align-items: center;\n    font-size: ", ";\n    color: ", ";\n  "], ["\n    display: flex;\n    text-decoration: none;\n    align-items: center;\n    font-size: ", ";\n    color: ", ";\n  "])), theme_1.theme.FONT_SIZE(12), theme_1.theme.COLOR('textTag'))
});
var TermsLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    cursor: pointer;\n    font-size: ", ";\n    color: ", ";\n    ", ";\n    margin-bottom: ", ";\n  "], ["\n    cursor: pointer;\n    font-size: ", ";\n    color: ", ";\n    ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.FONT_SIZE(12), theme_1.theme.COLOR('textTag'), theme_1.theme.FILL('textTag'), theme_1.theme.UNIT(2))
});
var EntityListLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LogoLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    text-decoration: none;\n  "], ["\n    text-decoration: none;\n  "])))
});
var EntityGroupStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var EntityListGroupStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var YearStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", ";\n    ", ";\n  "], ["\n    color: ", ";\n    font-size: ", ";\n    ", ";\n  "])), theme_1.theme.COLOR('textTag'), theme_1.theme.FONT_SIZE(12), theme_1.theme.FILL('textTag'))
});
var RightsReservedStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    white-space: nowrap;\n  "], ["\n    white-space: nowrap;\n  "])))
});
var CreditLogoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    height: 30px;\n    width: 90px;\n    margin-top: 2px;\n    margin-left: 4px;\n    margin-right: 4px;\n  "], ["\n    height: 30px;\n    width: 90px;\n    margin-top: 2px;\n    margin-left: 4px;\n    margin-right: 4px;\n  "])))
});
var OverlayStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    position: absolute;\n    height: 100vh;\n    width: 100%;\n    background: rgba(245, 245, 245, 0.8);\n    z-index: 200;\n  "], ["\n    position: absolute;\n    height: 100vh;\n    width: 100%;\n    background: rgba(245, 245, 245, 0.8);\n    z-index: 200;\n  "])))
});
var EntityValueConversationLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ConversationChannelItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    margin-left: ", ";\n    padding: ", " ", " ", " ", ";\n    border-left: 1px solid ", ";\n\n    ", "\n\n    &:last-child {\n      margin-bottom: ", ";\n    }\n  "], ["\n    margin-left: ", ";\n    padding: ", " ", " ", " ", ";\n    border-left: 1px solid ", ";\n\n    ", "\n\n    &:last-child {\n      margin-bottom: ", ";\n    }\n  "])), theme_1.theme.UNIT(6.5), theme_1.theme.UNIT(3), theme_1.theme.UNIT(1), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.COLOR('line-sidebar'), function (props) {
    return props.isActive && (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), theme_1.theme.COLOR('light'));
  }, theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Overlay: styled_components_1.default.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), OverlayStyles),
  Header: styled_components_1.default.header(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  LogoLink: (0, styled_components_1.default)(router_1.Link)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), LogoLinkStyles),
  Logo: (0, styled_components_1.default)(app_logo_1.AppLogo)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  MenuButton: (0, styled_components_1.default)(sidebar_menu_button_1.SidebarMenuButton)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  Body: styled_components_1.default.div(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Section: (0, styled_components_1.default)(sidebar_section_1.SidebarSection)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  EntityListLink: (0, styled_components_1.default)(entity_sidebar_list_link_1.EntitySidebarListLink)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), EntityListLinkStyles),
  EntityGroup: (0, styled_components_1.default)(entity_sidebar_group_1.EntitySidebarGroup)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), EntityGroupStyles),
  EntityListGroup: (0, styled_components_1.default)(entity_sidebar_list_group_1.EntitySidebarListGroup)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), EntityListGroupStyles),
  ConversationChannelItem: styled_components_1.default.div(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), ConversationChannelItemStyles),
  EntityValueConversationLink: (0, styled_components_1.default)(entity_value_conversation_link_1.EntityValueConversationLink)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), EntityValueConversationLinkStyles),
  Footer: styled_components_1.default.footer(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles),
  Copyright: styled_components_1.default.a(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), CopyrightStyles),
  CreditLogo: (0, styled_components_1.default)(shapeable_logo_1.ShapeableLogo)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), CreditLogoStyles),
  Year: (0, styled_components_1.default)(icon_label_1.IconLabel)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), YearStyles),
  RightsReserved: styled_components_1.default.span(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), RightsReservedStyles),
  TermsLink: (0, styled_components_1.default)(icon_label_1.IconLabel)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), TermsLinkStyles),
  TermsDialog: (0, styled_components_1.default)(dialog_1.Dialog)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), TermsDialogStyles),
  TermsContentScrollView: terms_content_scroll_view_1.TermsContentScrollView
};
var Sidebar = function (props) {
  var className = props.className;
  var _a = (0, use_sidebar_1.useSidebar)(),
    state = _a.state,
    toggle = _a.toggle,
    hideFloating = _a.hideFloating;
  var t = (0, use_lang_1.useLang)();
  var modal = (0, use_modal_1.useModal)();
  var Icons = (0, use_icons_1.useIcons)();
  var entities = (0, use_entities_1.useEntities)();
  var bodyRef = (0, react_1.useRef)();
  var onTermsClick = function () {
    modal.show(react_1.default.createElement(My.TermsDialog, {
      padBody: false,
      cancelLabel: "Close",
      title: t('Terms and Privacy Policy'),
      onCancel: function () {
        return modal.hide();
      }
    }, react_1.default.createElement(terms_content_scroll_view_1.TermsContentScrollView, null)));
  };
  var appSections = (0, use_app_sections_1.useAppSections)();
  var _b = (0, use_active_app_sections_1.useActiveAppSections)(),
    toggleSection = _b.toggle,
    isActive = _b.isActive;
  var _c = (0, use_active_app_sub_sections_1.useActiveAppSubSections)(),
    toggleSubSection = _c.toggle,
    isSubActive = _c.isActive;
  var screen = (0, use_app_screen_1.useAppScreen)();
  var followableEntities = (0, use_followable_entities_1.useFollowableEntities)();
  var user = (0, use_active_person_1.useActivePerson)();
  // console.log(first(user.user.roles))
  var _d = (0, use_conversation_channels_1.useConversationChannels)().conversationChannels,
    conversationChannels = _d === void 0 ? [] : _d;
  var person = user.person;
  var pageDefn = (0, use_entity_definition_named_1.useEntityDefinitionNamed)('Page');
  var personDict = person;
  var path = (0, current_path_name_1.currentPathName)();
  // we only want to show groups where the active person currently has following entries
  var followableEntitiesToShow = !person ? {} : (0, lodash_1.pickBy)(followableEntities, function (defn) {
    var fieldName = defn.followingFieldName;
    return personDict[fieldName] && !!personDict[fieldName].length;
  });
  ;
  var sidebarPages = (0, use_sidebar_pages_1.useSidebarPages)();
  var usesData = function (item) {
    return !!(item.children || []).find(function (child) {
      return child.type === 'list-expandable';
    });
  };
  var isFollowingAnything = !!(0, lodash_1.find)(followableEntitiesToShow, function (defn) {
    return personDict && personDict[defn.followingFieldName] && !!personDict[defn.followingFieldName].length;
  });
  var hasConversationChannels = !!conversationChannels.length;
  var appSectionsToShow = (0, lodash_1.sortBy)((0, lodash_1.filter)(appSections, function (item) {
    if (!isFollowingAnything && item.id === 'following') {
      return false;
    }
    return true;
  }), function (appSection) {
    return (0, lodash_1.indexOf)(['home'], appSection.id) || -2;
  });
  // splice in sidebar links
  var _e = __read(appSectionsToShow),
    home = _e[0],
    otherSections = _e.slice(1);
  var appSectionsWithPages = __spreadArray(__spreadArray([home], __read((sidebarPages.pages || []).map(function (page) {
    return {
      type: 'page',
      id: page.id,
      label: page.title || page.name,
      icon: function (_a) {
        var icons = _a.icons;
        return icons.PageNoCircle;
      },
      scopes: [],
      children: [],
      path: pageDefn.to(page.slug)
    };
  })), false), __read(otherSections), false);
  var navigateToSection = function (id) {
    var section = (0, lodash_1.find)(appSectionsWithPages, function (appSection) {
      return appSection.id === id;
    });
    if (section) {
      (0, router_1.navigate)(section.path);
      hideFloating();
    }
  };
  var sections = react_1.default.useMemo(function () {
    return (0, lodash_1.filter)(appSectionsWithPages.map(function (item, index) {
      var _a;
      var canRender = ((_a = item.scopes) === null || _a === void 0 ? void 0 : _a.length) ? (0, current_user_can_1.personCan)(user, item.scopes) : true;
      if (!canRender) {
        return null;
      }
      var sectionChildren = (0, lodash_1.filter)((item.children || []).map(function (child, childIndex) {
        var _a;
        var defn = child.entityTypeName && entities[child.entityTypeName];
        var canRenderChild = ((_a = child.scopes) === null || _a === void 0 ? void 0 : _a.length) ? (0, current_user_can_1.personCan)(user, child.scopes) : true;
        if (!canRenderChild) {
          return null;
        }
        if (child.type === 'list' && child.entityTypeName && defn && (0, current_user_can_1.personCanList)(user, defn.scopeSlug, defn.isPublic)) {
          return react_1.default.createElement(My.EntityListLink, {
            key: "".concat(child.id, "-").concat(childIndex),
            label: child.label,
            entityTypeName: child.entityTypeName
          });
        }
        if (child.type === 'following-tree' && isFollowingAnything && (0, current_user_can_1.personCan)(user, ['write:any'])) {
          return (0, lodash_1.map)(followableEntitiesToShow, function (defn) {
            var sectionId = "following/".concat(defn.slug);
            var onToggle = function () {
              return toggleSubSection(sectionId);
            };
            return react_1.default.createElement(My.EntityGroup, {
              isOpen: isSubActive(sectionId),
              onToggle: onToggle,
              key: sectionId,
              entityTypeName: defn.name,
              items: personDict ? personDict[defn.followingFieldName] : []
            });
          });
        }
        if (child.type === 'conversation-channels' && hasConversationChannels) {
          return (0, lodash_1.map)((0, lodash_1.filter)(conversationChannels, function (channel) {
            return !!entities[(0, lodash_1.get)(channel, 'entity.__typename', '')];
          }), function (channel, index) {
            var entity = channel.entity;
            var isActive = entity.slug === screen.slug && screen.entityTypeName === entity.__typename && screen.child === 'conversation';
            return react_1.default.createElement(My.ConversationChannelItem, {
              isActive: isActive
            }, react_1.default.createElement(My.EntityValueConversationLink, {
              key: "".concat(entity.id, "-").concat(index),
              entity: entity
            }));
          });
        }
        if (child.type === 'list-expandable' && child.entityTypeName && defn && (0, current_user_can_1.personCanRead)(user, defn.scopeSlug, defn.isPublic)) {
          var cdefn = entities[child.entityTypeName];
          var sectionId_1 = "".concat(item.id, "/").concat(cdefn.slug);
          var onToggle = function () {
            return toggleSubSection(sectionId_1);
          };
          var items = state.entities && state.entities[child.entityTypeName];
          if (cdefn) {
            return react_1.default.createElement(My.EntityGroup, {
              label: child.label,
              isOpen: isSubActive(sectionId_1),
              onToggle: onToggle,
              key: sectionId_1,
              entityTypeName: child.entityTypeName,
              items: items
            }, react_1.default.createElement(My.EntityListLink, {
              isAll: true,
              label: (0, sprintf_js_1.sprintf)(t('All %s'), cdefn.pluralLabel),
              entityTypeName: child.entityTypeName
            }));
          }
        }
        if (child.type === 'list-group') {
          var entityTypeNames = (child.entityType ? (0, lodash_1.map)((0, lodash_1.sortBy)((0, lodash_1.pickBy)(entities, function (defn) {
            return defn.type === child.entityType;
          }), function (defn) {
            return defn.pluralLabel;
          }), function (defn) {
            return defn.name;
          }) : child.entities) || [];
          if (entityTypeNames.length) {
            return react_1.default.createElement(My.EntityListGroup, {
              isOpen: isSubActive(child.id),
              label: child.label,
              onToggle: function () {
                return toggleSubSection(child.id);
              },
              key: child.id,
              entityTypeNames: entityTypeNames
            });
          }
        }
        return null;
      }));
      var canToggle = !(env_1.USE_SIMPLE_MENUS_FOR_NON_ADMINS && !(0, current_user_can_1.personCanAdmin)(user));
      // if nothing in the section can be rendered, this shouldn't render anything
      return (!(0, lodash_1.includes)(['list', 'list-expandable', 'list-group', 'parent'], item.type) || !!sectionChildren.length) && react_1.default.createElement(My.Section, {
        hasChildren: item.type !== 'feed' && item.children && !!item.children.length,
        key: "".concat(item.id, "-").concat(index),
        icon: item.icon && item.icon({
          icons: Icons,
          entities: entities
        }),
        onClick: navigateToSection,
        onToggle: toggleSection,
        canToggle: canToggle,
        isCurrent: screen.appSection && screen.appSection.id === item.id || (0, lodash_1.includes)(['page', 'latest'], item.type) && path === item.path,
        isOpen: !canToggle || isActive(item.id),
        hasBorder: index !== 0,
        name: item.label,
        id: item.id
      }, sectionChildren);
    }));
  }, [state, user]);
  // const entitiesObject = mapKeys(mapValues(entities, (defn) => {
  //   return mapValues(defn.form?.fields, (field, fieldName) => {
  //     let description = field.description;
  //     if (!description) {
  //       if (field.entityTypeName) {
  //         const linkedDefn = entities[field.entityTypeName];
  //         if (linkedDefn) {
  //           if (field.type === 'linked') {
  //             const notRequiredLabel = sprintf(t(`Is there %s associated with this %s?`), `{{${linkedDefn.templatePlaceholderA}}}`, `{{${defn.templatePlaceholder}}}`);
  //             const requiredLabel = sprintf(t(`Which %s is associated with this %s?`), `{{${linkedDefn.templatePlaceholder}}}`, `{{${defn.templatePlaceholderPlural}}}`);
  //             description = field.required ? requiredLabel : notRequiredLabel;
  //           } 
  //           if (field.type === 'linkedMultiple' || field.type === 'linkedTable') {
  //             const notRequiredMultiLabel = sprintf(t(`Does this %s have any associated %s?`), `{{${defn.templatePlaceholder}}}`, `{{${linkedDefn.templatePlaceholderPlural}}}`);
  //             const requiredMultiLabel = sprintf(t(`Which %s are associated with this %s?`), `{{${linkedDefn.templatePlaceholderPlural}}}`, `{{${defn.templatePlaceholder}}}`);
  //             description = field.required ? requiredMultiLabel : notRequiredMultiLabel;
  //           }
  //         }
  //       }
  //     }
  //     return pickBy({
  //       label: field.label,
  //       description
  //     });
  //   })
  // }), (defn, key) => kebabCase(key));
  return react_1.default.createElement(My.Container, {
    className: className
  }, screen.type === 'manage' && react_1.default.createElement(My.Overlay, null), react_1.default.createElement(My.Header, {
    className: "sidebar-header"
  }, react_1.default.createElement(My.LogoLink, {
    to: "/",
    target: "_top"
  }, react_1.default.createElement(My.Logo, null)), react_1.default.createElement(My.MenuButton, {
    className: "platform-menu-button",
    isOpen: state.isShown,
    onClick: toggle
  })), react_1.default.createElement(My.Body, {
    ref: bodyRef
  }, sections), react_1.default.createElement(My.Footer, null, react_1.default.createElement(My.TermsLink, {
    icon: react_1.default.createElement(Icons.InfoCircle, null),
    iconSize: 16,
    onClick: onTermsClick
  }, t('Terms of Use and Privacy Policy')), react_1.default.createElement(My.Copyright, {
    target: "_blank",
    href: "https://shapeable.ai"
  }, react_1.default.createElement(My.Year, {
    icon: react_1.default.createElement(Icons.CCircle, null),
    iconSize: 16
  }, new Date().getFullYear()), react_1.default.createElement(My.CreditLogo, null), react_1.default.createElement(My.RightsReserved, null, t('All Rights Reserved')))));
};
exports.Sidebar = Sidebar;
exports.Sidebar.defaultProps = exports.SidebarDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44;